// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"y0","cross":"y1","iconSVGWrapper":"y2","iconSVG":"y3","iconSVGDark":"y4"};